import React, { Component } from 'react';
import styled, { css, withTheme } from 'styled-components';
import PageHeader from '../components/PageHeader';
import PageHeaderMenu, { menuItemStyle } from '../components/PageHeaderMenu';
import __ from '../utils/translator';
import GlossaryStoreActions from '../flux/GlossaryStoreActions';
import GlossaryStore from '../flux/GlossaryStore';
import TagStore from '../flux/TagStore';
import TermList from '../components/TermList'
import ArrowDown from '../icons/ArrowDown';
import {
  DropDownItemsList,
  DropDownItem,
  DropDownItemCheckbox,
  DropDownItemCheck,
  DropDownButton,
} from '../components/DropDown';
import thronThumbnail from '../utils/thronThumbnail';
import buttonMutedStyle from '../utils/buttonMutedStyle';
import DropDown from '../components/DropDown';
import PageTitle from '../components/PageTitle';
import RenderOnTablet from "../components/responsive/RenderOnTablet";
import RenderOnMobile from "../components/responsive/RenderOnMobile";
import GlossaryFilterStore from "../flux/GlossaryFilterStore";
import { Route, withRouter } from "react-router-dom";
import GlossaryFilter from "./GlossaryFilter";
import GlossaryTerm from "./GlossaryTerm";
import ModalFullscreenActions from "../flux/ModalFullscreenActions";
import themeResponsiveProperty
  from '../components/responsive/themeResponsiveProperty';
import Header from '../components/organisms/Header';

// This is a function instead of a simple array because we need to re-compute it
// when the application language changes (and thus forces the component to
// reload).
const alphabeticalFilter = () => ([
  { name: __('All'), to: null },
  { name: __('A-F'), to: 'a-f', },
  { name: __('G-M'), to: 'g-m', },
  { name: __('N-P'), to: 'n-p', },
  { name: __('Q-Z'), to: 'q-z', },
]);

const SORT_OPTION_ALPHABETICAL = 'alphabetical';
const SORT_OPTION_NEWEST = 'newest';

const sortOptions = [
  { name: SORT_OPTION_ALPHABETICAL, value: __('Alphabetical') },
  { name: SORT_OPTION_NEWEST, value: __('Newest') },
];

function getLetterRange(letterRange) {
  const activeAlphabeticalFilter = alphabeticalFilter().find(item => (
    item.to === letterRange
  ));

  if (activeAlphabeticalFilter === undefined) {
    console.error("Invalid location, invalid alphabetical filter.");
    return null;
  }

  return activeAlphabeticalFilter.name;
}

class GlossaryComponent extends Component {

  filter = GlossaryFilterStore.getState();

  state = {
    terms: [],
    tags: TagStore.getState(),
    isSortDropDownOpen: false,
    isFilterDropDownOpen: false,
    letterRange: this.filter.letterRange,
    currentSortOption: this.filter.currentSortOption,
    currentFilterTagList: this.filter.currentFilterTagList,
  };

  subscriptions = [];
  filterDropdownReference = null;

  componentDidMount() {
    GlossaryStoreActions.getAllTerms();
    ModalFullscreenActions.toggleFilterIcon(true);

    this.subscriptions.push(GlossaryStore.addListener(() => {
      this.setState({ terms: GlossaryStore.getState() });
    }));

    this.subscriptions.push(TagStore.addListener(() => {
      this.setState({ tags: TagStore.getState() });
    }));

    this.subscriptions.push(GlossaryFilterStore.addListener(() => {
      const filter = GlossaryFilterStore.getState();
      this.setState({ letterRange: filter.letterRange });
    }));

    window.document.addEventListener('mousedown', this.onDocumentClick.bind(this), false);
  };

  componentDidUpdate(prevProps, prev) {
    // if (this.props.location.pathname !== prevProps.location.pathname) {
    //   this.setState({
    //     isSortDropDownOpen: false,
    //     isFilterDropDownOpen: false,
    //   });
    // }
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());

    window.document.removeEventListener('mousedown', this.onDocumentClick.bind(this), false);
  }

  // @todo 2018-10-17 Replace with onClickOutside HOC for both drop-downs
  onDocumentClick = e => {
    if (
      this.filterDropdownReference !== null &&
      this.state.isFilterDropDownOpen === true &&
      ! this.filterDropdownReference.contains(e.target)
    ) {
      this.setState({ isFilterDropDownOpen: false });
    }
  };

  handleSortByClick = () => {
    this.setState({
      isSortDropDownOpen: ! this.state.isSortDropDownOpen,
      isFilterDropDownOpen: false,
    });
  };

  handleFilterByClick = () => {
    this.setState({
      isSortDropDownOpen: false,
      isFilterDropDownOpen: ! this.state.isFilterDropDownOpen,
    });
  };

  handleSortByItemClick = option => {
    this.setState({
      currentSortOption: option,
      isSortDropDownOpen: false,
    });
  };

  handleFilterByTagClick = id => {
    let currentFilterTagList = [...this.state.currentFilterTagList];
    let pos = currentFilterTagList.indexOf(id);
    //remove tag from list
    if(pos>=0){
      currentFilterTagList.splice(pos, 1);
    }else{
      currentFilterTagList.push(id)
    }
    this.setState({ currentFilterTagList });
  };

  render() {
    // noinspection JSUnresolvedVariable
    const terms = sortByOption(
      this.state.currentSortOption,
      filterByTagList(
        this.state.currentFilterTagList,
        filterByLetterGroup(
          this.state.letterRange,
          this.state.terms
        )
      )
    );

    return (
      <div>
        <Header actions={themeResponsiveProperty(['glossary-filter', 'close-fullscreen-modal'], undefined)(this.props)} />

        {this.state.letterRange === null ? (
          <PageTitle withTracking title="Glossary" />
        ) : (
          <PageTitle
            key={getLetterRange(this.state.letterRange)}
            withTracking
            title={`Glossary / ${getLetterRange(this.state.letterRange)}`} />
        )}

        <PageHeader
          smallTitle
          crumbs={[__('Home'), __('Glossary')]}
          title={__('Glossary')}
          cover={themeResponsiveProperty(null, thronThumbnail(this.props.theme.pageHeaderContentId.glossary))(this.props)}>

          <RenderOnTablet>
            <PageHeader.MenuContainer>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}>
                <PageHeaderMenu style={{ fontSize: '1rem' }}>
                  {alphabeticalFilter().map((item, index) => (
                    <AlphabeticalFilterItem
                      key={index}
                      isActive={this.state.letterRange === item.to}
                      onClick={() => this.setState({letterRange: item.to})}
                    >
                      {item.name}
                    </AlphabeticalFilterItem>
                  ))}
                </PageHeaderMenu>

                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#fff',
                }}>
                  <DropDown style={{ marginRight: '3rem' }}>
                    <DropDownButton
                      style={{
                        ...buttonMutedStyle,
                        ...menuItemStyle,
                        paddingRight: '2.5rem',
                        paddingLeft: '2.5rem',
                      }}
                      onClick={this.handleSortByClick}
                    >
                      {__('Sort by')}
                      <ArrowDown width=".875rem" style={{ marginLeft: '.5rem' }} />
                    </DropDownButton>

                    <DropDownItemsList
                      open={this.state.isSortDropDownOpen}
                      style={{ right: 0, left: 0, top: '100%' }}
                    >
                      {sortOptions.map(sortType => (
                        <DropDownItem
                          key={sortType.name}
                          selected={this.state.currentSortOption === sortType.name}
                          onClick={() => this.handleSortByItemClick(sortType.name)}>
                          {__(sortType.value)}

                          {this.state.currentSortOption === sortType.name && (
                            <DropDownItemCheck/>
                          )}
                        </DropDownItem>
                      ))}
                    </DropDownItemsList>
                  </DropDown>

                  <DropDown ref={ref => this.filterDropdownReference = ref}>
                    <DropDownButton
                      style={{
                        ...buttonMutedStyle,
                        ...menuItemStyle,
                      }}
                      onClick={this.handleFilterByClick}
                    >
                      {__('Filter by')}
                      <ArrowDown width=".875rem" style={{marginLeft: '.5rem',}}/>
                    </DropDownButton>

                    <DropDownItemsList
                      open={this.state.isFilterDropDownOpen}
                      style={{ right: 0, top: '100%', width: '20rem' }}
                    >
                      {this.state.tags.map(tag => (
                        <DropDownItem
                          key={tag.id}
                          selected={this.state.currentFilterTagList.indexOf(tag.id) !== -1}
                          onClick={() => this.handleFilterByTagClick(tag.id)}>
                          {__(tag.name)}
                          <DropDownItemCheckbox readOnly checked={this.state.currentFilterTagList.indexOf(tag.id) >= 0} />
                        </DropDownItem>
                      ))}
                    </DropDownItemsList>
                  </DropDown>
                </div>
              </div>
            </PageHeader.MenuContainer>
          </RenderOnTablet>
        </PageHeader>

        <RenderOnMobile>
          <Container>
            <AlphabeticalFilterHeader style={{
              marginRight: '-.25rem',
              marginLeft: '-.25rem',
            }}>
              {alphabeticalFilter().map((item, index) => (
                <AlphabeticalFilterItem
                  key={index}
                  isActive={this.state.letterRange === item.to}
                  onClick={() => GlossaryStoreActions.updateLetterRange(item.to)}
                >
                  {item.name}
                </AlphabeticalFilterItem>
              ))}
            </AlphabeticalFilterHeader>
          </Container>
        </RenderOnMobile>

        <TermList terms={terms} />
      </div>
    );
  }
}

GlossaryComponent.defaultProps = {
  letterRange: null,
};

const GlossaryComponentWithHOC = withTheme(GlossaryComponent);

export default withTheme(withRouter(function Glossary(props){

  return (
    props.theme.isMobile ? (
      <React.Fragment>
        <Route exact path="/" component={GlossaryComponentWithHOC} />
        <Route path="/glossary-filter" component={GlossaryFilter} />
        <Route exact path="/:id(\d+)" component={GlossaryTerm} />,
      </React.Fragment>
    ) : props.theme.isTablet ? (
      <GlossaryComponentWithHOC {...props} />
    ) : null
  )
}));

const AlphabeticalFilterItem = styled.span`

  ${themeResponsiveProperty(css`
    flex: 1;
    margin-right: .25rem;
    margin-left: .25rem;
    padding: .125rem;
    border: .0625rem solid #000;
    border-radius: .375rem;
    background-color: #fff;
    color: #000;
    font-size: .75rem;
    text-align: center;
    text-transform: uppercase;

    ${props => props.isActive && css`
      color: #fff;
      background-color: #000;
    `};
  `, css`
    margin-top: -1rem;
    margin-right: 3rem;
    margin-bottom: -1rem;
    padding-top: .75rem;
    padding-bottom: .75rem;
    width: 3.125rem;
    color: #fff;
    text-align: center;

    ${props => props.isActive && css`
      color: #252525;
      background-color: #fff;
      box-shadow: rgba(0,0,0,.3) 0 1px 3px;
    `};
  `)};
`;

const AlphabeticalFilterHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Container = styled.div`
  padding: ${themeResponsiveProperty('.125rem 1rem 0', '0 1.25rem')};
`;

function sortByOption(option, terms) {
  switch (option) {
    case SORT_OPTION_ALPHABETICAL:
      return terms.slice().sort((term1, term2) => {
        if (term1.name < term2.name) {
          return -1;
        } else if (term1.name > term2.name) {
          return 1;
        } else {
          return 0;
        }
      });

    case SORT_OPTION_NEWEST:
      return terms.slice().sort((term1, term2) => {
        if (term1.createdAt > term2.createdAt) {
          return -1;
        } else if (term1.createdAt < term2.createdAt) {
          return 1;
        } else {
          return 0;
        }
      });

    default:
      throw new Error(`Invalid sort option [${option}].`);
  }
}

function filterByTagList(tags, terms) {
  if (tags.length === 0) {
    return terms;
  }

  return terms.filter(term => {
    return tags.every(tag => term.tags.some(termTag => termTag.id === tag))
  });
}

function filterByLetterGroup(group, terms) {
  if (group === null) {
    return terms;
  }

  const patternRange = new RegExp(`[${group.toLowerCase()}]`) ;

  return terms.filter(term => {
    return patternRange.test(term.name[0].toLowerCase());
  });
}
